import React, {Component} from "react";
import {Card, CardHeader, TabContent, TabPane} from "reactstrap";
import AppointmentHour from "./AppointmentHour";
import moment from "moment";

class AppointmentCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
           dates:[],
           datesMap:{},
           selectedDate:null
        };
    }

    componentDidMount () {
        let {appointmentHourList}=this.props;
        let dates=[];
        let selectedDate = null;
        for (let date in appointmentHourList) {
            dates.push(date);
        }
        dates.sort((date1, date2) =>new Date(date1) - new Date(date2));
        if(dates && dates.length>0)
            selectedDate=dates[0];
        this.setState({dates,selectedDate});
    }

    render() {
        return (<Card className="">
            <CardHeader>
                <div className="nav-tabs-navigation">
                    <div className="nav-tabs-wrapper">
                        <ul className="nav tabBackground nav-tabs" data-tabs="tabs" style={{letterSpacing:-0.5}}>
                            {this.state.dates.map((date, index) =>
                                <li className="nav-item" key={index}>
                                    <a className={"nav-link " + (this.state.selectedDate === date ? 'active' : '')}
                                       onClick={() => {this.setState({selectedDate: date})}}
                                       data-toggle="tab">{moment(date).format("DD-MM-YYYY")}</a>
                                </li>
                            )}
                        </ul>
                        <hr></hr>
                    </div>
                </div>
            </CardHeader>
            <TabContent activeTab={this.state.selectedDate}>
                {this.state.dates.map((date, index) =>
                    <TabPane tabId={date} key={index}>
                        <AppointmentHour
                            date={date}
                            loading={this.props.loading}
                            handleHour={(date,hour,minute)=>this.props.handleDate(date,hour,minute)}
                            appointmentHours={this.props.appointmentHourList[date]}
                        />
                    </TabPane>
                )}
            </TabContent>
        </Card>)
    }
}

export default AppointmentCard;